import { PlaceholderComponent } from ".";

function Home() {
  return (
    <PlaceholderComponent />
  );
}

export default Home;
